/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../binfo/api';
import '../common/common';
import '../../common/gateways';
import '../../payments/network_numerics';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "GatewayData": {
                "fields": {
                  "gatewayId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "gatewayTransactionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gatewayState": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "methodOfPayment": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "retrievalReferenceNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "gatewayExtensions": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "debitNetwork": {
                    "type": ".squareup.binfo.api.DebitNetwork",
                    "id": 7,
                    "rule": "optional"
                  },
                  "paymentRoute": {
                    "type": ".squareup.esperanto.common.PaymentRoute",
                    "id": 8,
                    "rule": "optional"
                  },
                  "targetAcquirer": {
                    "type": ".squareup.common.gateways.AcquirerName",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isUnroutable": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "networkNumerics": {
                    "type": ".squareup.payments.networknumerics.NetworkNumerics",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.GatewayData) {
  $root.addJSON(jsonData);
}

/**
 * Gateway data.
 *
 * SOURCE GatewayData @ squareup/esperanto/model/gateway.proto at 16:1
 */
export const GatewayData = $root.lookupType('squareup.esperanto.model.GatewayData');
fixType(GatewayData, {
  gatewayId: {
    required: true
  }
});
Builder.createAndAttachToType(GatewayData);